import React from 'react';
import { FontWeights, getTheme, mergeStyleSets, Modal } from '@fluentui/react';
import ButtonSecondaryComponent from '../button-secondary/button-secondary.component';

import ItemCliente from '../../models/ItemCliente';

const theme = getTheme();

const classes = mergeStyleSets({
    modalContainer: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
        width: '50vw',
    },
    modalHeader: [
        theme.fonts.xLargePlus, {
            flex: '1 1 auto',
            color: theme.palette.neutralPrimary,
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: FontWeights.semibold,
            padding: '12px 12px 14px 24px',
        },
    ],
    modalBody: {
        flex: '4 4 auto',
        padding: '24px',
        overflowY: 'auto',
        selectors: {
            p: { 
                margin: '14px 0',
            },
            'p:first-child': { 
                marginTop: 0, 
            },
            'p:last-child': { 
                marginBottom: 0, 
            },
        },
    },
});

interface ISelectSpaceComponentProps {
    customers: ItemCliente[];
    onSelectCustomer: (customer: ItemCliente) => void;
};

const SelectSpaceComponent = (props: ISelectSpaceComponentProps) => {
    return (
        <Modal
            titleAriaId="select-customer-modal"
            isOpen={true}
            isBlocking={false}
            containerClassName={classes.modalContainer}>
            <div className={classes.modalBody}>
                <p>
                    Selecciona el espacio de nombres al que quieres conectar...
                </p>
                {
                    props.customers.map((customer: ItemCliente) =>
                        <div key={customer.CodigoCliente}>
                            <ButtonSecondaryComponent
                                text={customer.Nombre}
                                onClick={() => props.onSelectCustomer(customer)} />
                            <br/>
                        </div>
                    )
                }
            </div>
        </Modal>
    );
};

export default SelectSpaceComponent;
